module.exports = __webpack_public_path__ + "static/media/DesignSmartIcon.7b95abb2.svg";